import { defineRecipe, defineSlotRecipe } from '@chakra-ui/react'

// Input / Textarea / NativeSelect: tightened radius (radii.sm) + comfortable
// 40px / compact 32px control height, matching button.recipe.ts's control
// height so Input and the native <select> stop looking foreign next to each
// other (spec §1 defect). See button.recipe.ts for the full rationale on why
// the density condition must be consumed as `_compact` (underscore-prefixed)
// rather than the bare `compact` key declared in conditions.ts — Chakra v3's
// createConditions() remaps every custom condition to an internal `_`-prefixed
// key before it is recognized inside style objects; a bare `compact:` key is
// silently dropped by the recipe compiler.
//
// Density is scoped to BOTH `sm` and `md` (not md-only): most call sites use
// size="sm" (~90 sites app-wide), so an md-only override left the common case
// cramped and created an Input(sm, stock 2.25rem) vs NativeSelect(all sizes,
// 2.5rem) mismatch. Applying densityH at sm+md makes every control 40/32
// regardless of the size prop and keeps Input == NativeSelect (review fix
// round 1, plan owner confirmed).
const densityH = { h: '2.5rem', minH: '2.5rem', _compact: { h: '2rem', minH: '2rem' }, _touch: { h: '2.75rem', minH: '2.75rem' } }
const focusRing = {
  _focusVisible: {
    borderColor: 'accent',
    boxShadow: '0 0 0 1px var(--chakra-colors-accent)',
  },
}

export const inputRecipe = defineRecipe({
  base: { borderRadius: 'sm', borderColor: 'border', ...focusRing },
  variants: { size: { sm: densityH, md: densityH } },
})

export const textareaRecipe = defineRecipe({
  base: { borderRadius: 'sm', borderColor: 'border', ...focusRing },
})

// NOTE (out of scope, tracked only): a Field.Root ancestor overrides
// NativeSelect's `disabled` prop (see memory/chakra-v3-field-root-disabled-override.md).
// Not addressed here — this recipe only aligns radius/height/focus ring with Input.
export const nativeSelectSlotRecipe = defineSlotRecipe({
  slots: ['root', 'field', 'indicator'],
  base: { field: { borderRadius: 'sm', borderColor: 'border', ...focusRing } },
  variants: { size: { sm: { field: densityH }, md: { field: densityH } } },
})
